class MycrmSearchInputCtrl {
  onClearSearch() {
    this.value = '';
    this.onSubmit({ query: this.value });
  }
}

export default MycrmSearchInputCtrl;
